import * as actions from './rfr-mon-save.actions';
import * as i18nInterface from 'src/app/shared/_config/i18n/i18n-interface';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { SpxCapitalizePipe } from '@softpak/components/spx-capitalize';
import { TranslateService } from '@ngx-translate/core';
import { loadingRfrMonSave } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class RfrMonSaveEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);
  private readonly translateService = inject(TranslateService);


  load$ = createEffect(() =>
    this.actions$.pipe(ofType(actions.load),
      mergeMap((params) => this.sharedGenericService.invoke(ApiRfrMethod.rfrMonSave, params.query).pipe(
        map((data) => actions.received({ data })),
        catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })])
      ))
    ));

  onError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap((action: { messageText: string }) => {
      return [
        spxToasterActions.createError({
          autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
          messageText: action.messageText,
        })
      ]
    })
  ));

  afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.load),
    mergeMap(() => [
      spxSpinnerActions.show({
        action: loadingRfrMonSave
      }),
    ]))
  );

  afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap(() => [
      spxToasterActions.createError({
        messageText: SpxCapitalizePipe.transform(this.translateService.instant(i18nInterface.textNotProcessed)),
        title: SpxCapitalizePipe.transform(this.translateService.instant(i18nInterface.textReeferMonitoring)),
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
      }),
      spxSpinnerActions.hide({
        action: loadingRfrMonSave
      }),
    ]))
  );

  afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.received),
    mergeMap(() => [
      spxToasterActions.createSuccess({
        messageText: SpxCapitalizePipe.transform(this.translateService.instant(i18nInterface.textProcessed)),
        title: SpxCapitalizePipe.transform(this.translateService.instant(i18nInterface.textReeferMonitoring)),
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
      }),
      spxSpinnerActions.hide({
        action: loadingRfrMonSave
      }),
    ]))
  );
}
